export default "__VITE_PUBLIC_ASSET__92b43ade__"